"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
require("../../components/Admin/Knowledge/Style/style.scss");
var icons_1 = __importDefault(require("../../theme/icons"));
var Button_1 = __importDefault(require("../Button/Button"));
var customStyles = {
    content: {
        top: "0%",
        left: "0%",
        right: "auto",
        bottom: "auto",
        padding: 0,
        margin: 0,
        // background: "black",
        background: "transparent",
    },
};
var ReactModal = function (_a) {
    var title = _a.title, onSaveClick = _a.onSaveClick, isClose = _a.isClose, isOpen = _a.isOpen, children = _a.children, modalCardStyle = _a.modalCardStyle, showSaveButton = _a.showSaveButton, labelSaveButton = _a.labelSaveButton, saveIconName = _a.saveIconName;
    function ModalHeader() {
        return (react_1.default.createElement("div", { className: "modal-header" },
            react_1.default.createElement("div", { className: "modal-title" },
                " ",
                title,
                " "),
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                } },
                showSaveButton && (react_1.default.createElement(Button_1.default, { className: labelSaveButton ? "modal-button-text" : "modal-button", icon: react_1.default.createElement(icons_1.default, { className: "icon", height: 30, name: saveIconName ? saveIconName : "tick", width: 30 }), onClick: onSaveClick, text: labelSaveButton ? labelSaveButton : "", style: { marginRight: "1vw" } })),
                react_1.default.createElement(Button_1.default, { className: "modal-button", icon: react_1.default.createElement(icons_1.default, { className: "icon", height: 20, name: "cancel", width: 20 }), onClick: function () {
                        isClose();
                    } }))));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_modal_1.default, { appElement: document.getElementById("main") || undefined, ariaHideApp: false, contentLabel: "Add_my_finance_header", isOpen: Boolean(isOpen), style: customStyles },
            react_1.default.createElement("div", { className: "modal" },
                react_1.default.createElement("div", { className: "modal-card", style: __assign({ marginTop: "8vh" }, modalCardStyle) },
                    ModalHeader(),
                    react_1.default.createElement("div", { className: "content" }, children))))));
};
exports.default = ReactModal;
